import { getBoardRecommendPins } from "@/services";
import { useInfiniteList } from "@/utils/hooks/useInfiniteList";
import { useMemoizedFn } from "ahooks";
import { useRef } from "react";

export function useRecommendPins(boardId: number, pins: { file_id: number }[]) {
  const pageRef = useRef<number>(1);

  const queryFn = useMemoizedFn(async () => {
    const res = await getBoardRecommendPins({
      board_id: boardId,
      limit: 40,
      page: pageRef.current,
      pins,
    });

    if (res?.err) {
      return [];
    }

    pageRef.current = pageRef.current + 1;

    return res?.pins || [];
  });

  const { list: dataSource, hasMore, onLoadMore } = useInfiniteList(queryFn);

  return {
    pins: dataSource,
    hasMore,
    onLoadMore,
  };
}
